var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Lottie',{staticClass:"animation",attrs:{"id":"map-netherlands","options":_vm.mapAnimationOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }